function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  x1: "0%",
  y1: "50.7%",
  y2: "50.7%",
  id: "brave-a"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F50",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F50",
  offset: "41%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FF2000",
  offset: "58.2%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FF2000",
  offset: "100%"
})), /*#__PURE__*/React.createElement("linearGradient", {
  x1: "2.1%",
  y1: "50.7%",
  y2: "50.7%",
  id: "brave-b"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FF452A",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FF2000",
  offset: "100%"
})), /*#__PURE__*/React.createElement("path", {
  d: "M170 25L148 0H70L47 25s-19-5-29 4c0 0 27-2 36 12l27 5 17-5 11-2 11 2c6 2 13 5 17 5l27-5c9-14 35-12 35-12-9-9-29-4-29-4",
  id: "brave-c"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M210 61l6-14-17-18c-9-9-29-4-29-4L148 0H70L47 25s-19-5-29 4L2 47l6 14-8 22 25 95c5 21 9 29 23 39l46 31c4 3 10 7 15 7s10-4 14-7l46-31c15-10 18-18 24-39l25-95-8-22z",
  fill: "url(#brave-a)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M164 41s29 35 29 43c0 7-4 9-8 13l-21 23c-2 2-6 5-4 11 3 6 6 13 2 21s-11 13-15 12c-5-1-15-6-19-9-4-2-16-13-16-17 0-3 12-10 15-12 2-2 13-8 13-10l-3-9c-3-6-9-14-8-19 1-6 10-8 17-11l20-8c2 0 2-1-3-2-5 0-19-2-25 0s-16 4-17 6c-1 1-2 1-1 6l6 31c0 4 1 7-3 8l-14 3-14-3c-5-1-4-4-3-8l5-31v-6c-1-2-12-4-18-6s-19 0-24 0c-5 1-5 2-4 2l21 8c6 3 16 5 17 11 1 5-5 13-8 19s-4 7-3 9c0 2 11 8 13 10s15 9 15 12c0 4-12 15-16 17l-19 9c-5 1-12-4-16-12s0-15 2-21c3-6-1-9-3-11L32 97c-3-4-7-6-7-13 0-8 29-43 29-43l27 5 17-5 11-2 11 2c6 2 13 5 17 5l27-5zm-21 133c1 1 0 3-1 5l-26 19c-2 2-5 5-7 5s-5-3-8-5l-25-19c-2-2-3-4-1-5l15-8 19-7 19 7 15 8z",
  fill: "#FFF"
}), /*#__PURE__*/React.createElement("use", {
  fill: "url(#brave-b)",
  xlinkHref: "#brave-c"
}));

function SvgBrave(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 218 256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrave);
export default __webpack_public_path__ + "static/media/brave.5ca05d52.svg";
export { ForwardRef as ReactComponent };